<template>
  <div>
    <section class="container">
      <h1>Billing</h1>
      <button class="press action-colour" @click.stop.prevent="$router.push('settings/payments')">Add Payment Method</button>
      <div class="card">
        <div v-for="(site, idx) in siteMap" :key="site + idx" class="box">
          <h3 class="title">{{ site.site }}</h3>
          <p class="blue">KDS: {{ site.stations.kds.length }}</p>
          <p class="blue">POS: {{ site.stations.pos.length }}</p>
          <p class="blue">Total Stations: {{ site.stations.kds.length + site.stations.pos.length }}</p>
          <div v-if="site.stations.kds.length + site.stations.pos.length > 0">
            <p>Site fee: <CurrencyFormatter :value="itemPrices.site" :currency="companySettings.currency"/></p>
            <p v-if="site.stations.pos.length">POS: {{ site.stations.pos.length }} × <CurrencyFormatter :value="itemPrices.pos" :currency="companySettings.currency"/></p>
            <p v-if="site.stations.kds.length">KDS: {{ site.stations.kds.length }} × <CurrencyFormatter :value="itemPrices.kds" :currency="companySettings.currency"/></p>
            <h3>Site total: <CurrencyFormatter :value="siteSubtotal(site)" :currency="companySettings.currency"/> / mo</h3>
          </div>
          <h3 v-else>This site has no stations yet...</h3>
        </div>
        <div class="box">
          <h3>Company wide</h3>
          <p class="blue">Total Stations: {{ totalStations }}</p>
          <p v-if="cogsEnabled" class="blue">COGS: <CurrencyFormatter :value="itemPrices.cogs" :currency="companySettings.currency"/></p>
          <h3>Monthly Total: <CurrencyFormatter :value="monthlyTotal" :currency="companySettings.currency"/></h3>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { CurrencyFormatter } from "@monolith/components";

export default {
  name: "Billing",
  emits: ["handleMenu"],
  components: {
    CurrencyFormatter,
  },
  computed: {
    ...mapGetters({
      sites: "sites",
      siteMap: "siteMap",
      cogsEnabled: "cogsEnabled",
      companySettings: "companySettings",
      beamyProducts: "beamyProducts",
    }),

    itemPrices() {
      const prices = { pos: 0, kds: 0, site: 0, cogs: 0 };
      if (!this.beamyProducts || !this.beamyProducts.products) return prices;
      this.beamyProducts.products.forEach((p) => {
        if (p.metadata && p.metadata.type) prices[p.metadata.type] = p.unit_amount / 100;
      });
      return prices;
    },

    totalStations() {
      let total = 0;
      this.siteMap.forEach((site) => {
        total += site.stations.kds.length + site.stations.pos.length;
      });
      return total;
    },

    monthlyTotal() {
      let total = 0;
      this.siteMap.forEach((site) => {
        total += this.itemPrices.site;
        total += site.stations.pos.length * this.itemPrices.pos;
        total += site.stations.kds.length * this.itemPrices.kds;
      });
      if (this.cogsEnabled) total += this.itemPrices.cogs;
      return total;
    },
  },

  methods: {
    siteSubtotal(site) {
      return this.itemPrices.site +
        site.stations.pos.length * this.itemPrices.pos +
        site.stations.kds.length * this.itemPrices.kds;
    },
  },
};
</script>

<style scoped lang="scss">
@use "@monolith/styles";
h1 {
  margin: 1rem;
}
.container {
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: wrap;
  // padding-top: 1rem;
  h2,
  h1 {
    flex: 1 0 100%;
  }
  .card {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    border-radius: 10px;
    background: var(--primary-colour);
    box-shadow: var(--box-shadow);
    margin: 1rem;
    padding: 0.5rem;
    width: 100%;
    height: 100%;
    .blue {
      color: var(--action-colour);
    }
    .title {
      text-transform: capitalize;
    }
  }

  .box {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    min-height: 12rem;
    height: 100%;
    width: 18.5rem;
    border-radius: 5px;
    margin: 0.5rem;
    padding: 0.5rem;
    box-shadow: var(--box-shadow);
    background-color: var(--tertairy-colour);
    p {
      margin: 0.5rem;
      text-transform: capitalize;
    }
    h3 {
      margin: 0.5rem;
    }
  }

  .press {
    background-color: var(--action-colour);
    box-shadow: var(--box-shadow);
    color: var(--secondary-text-colour);
    &:active {
      scale: 0.95;
    }
  }
}
@media only screen and (orientation: portrait) {
  .container {
    flex-direction: column;
    width: 90%;
    h2 {
      width: 50%;
    }
    .card {
      flex-direction: column;
      margin: 0.75rem;
    }
    .box {
      width: 90%;
    }
  }
}
</style>
